import React from 'react';
import { useDialogsContext } from '../../../contexts/Dialog';
import Button from '../../BuildingBlocks/Button/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  plusButton: {
    marginRight: theme.spacing(1),
    height: '87px',
    width: '87px',
    backgroundColor: theme.palette.brand.greyLight,
    '&:hover': {
      backgroundColor: theme.palette.brand.blueGrey,
    },
    opacity: (lineOnEditMode) => (lineOnEditMode ? '70%' : '100%'),
  },
  background: {
    backgroundColor: theme.palette.brand.white,
  },
}));

export default function NewProductButton({ lineOnEditMode }) {
  const classes = useStyles(lineOnEditMode);
  const dialogs: any = useDialogsContext();

  return (
    <div className={classes.background}>
      <Button
        fullWidth={true}
        className={classes.plusButton}
        tooltipText={'Add new product'}
        onClick={() => dialogs.open('addProduct')}
        disabled={lineOnEditMode}
      >
        <img src={'icons/plus.svg'} alt="Add new product" />
      </Button>
    </div>
  );
}
